import React from "react";
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import {Box} from "@mui/material";
import budweiser from "assets/images/logos/budweiser.png";
import hisense from "assets/images/logos/hisense.png";
import mcdonalds from "assets/images/logos/mcdonalds.png";
import vivo from "assets/images/logos/vivo.png";

const Title = styled.h6`
	color: #fff;
	font-size: 14px;
	font-weight: 500;
	text-align: center;
	margin-bottom: 30px;
`;

const SponsorLink = styled.a`
	margin-left: 40px;
	margin-right: 40px;
	margin-bottom: 50px;
`;

const LINKS = [
	{
		name: "Budweiser",
		logo: budweiser,
		href: "",
	},
	{
		name: "Hisense",
		logo: hisense,
		href: "",
	},
	{
		name: "McDonalds",
		logo: mcdonalds,
		href: "",
	},
	{
		name: "Vivo",
		logo: vivo,
		href: "",
	},
];

export const SponsorLinks: React.FC = () => {
	const {t} = useTranslation();

	return (
		<Box>
			<Title>{t("footer.fifa.sponsors")}</Title>
			<Box
				sx={{
					display: "flex",
					justifyContent: "center",
					flexWrap: "wrap",
				}}>
				{LINKS.map((link) => (
					<SponsorLink key={link.name} href={link.href}>
						<img src={link.logo} alt={link.name} />
					</SponsorLink>
				))}
			</Box>
		</Box>
	);
};
